<p-card styleClass="flex w-full h-full p-4">
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center">
      <h2>Location Quick Notes</h2>
      <app-icon-button 
          *ngIf="showEditButton"
          [icon]="icons.solid.faPenToSquare" 
          textSize="text-lg" 
          [pTooltip]="'Edit Location Quick Notes'" 
          [showDelay]="500"
          (click)="editLocationQuickNotes()">
      </app-icon-button>
    </div>
  </ng-template>
  <div class="content">
    <div *ngIf="loading" class="loading">
      Loading location quick notes...
    </div>
    <div *ngIf="error" class="error">
      {{ error }}
    </div>
    <div *ngIf="!loading && !error">
      <p-table [value]="quickNotes()" 
               [rows]="10" 
               [paginator]="true"
               [rowsPerPageOptions]="[10, 25, 50, 100]"
               styleClass="p-datatable-sm">
        <ng-template pTemplate="header">
          <tr>
            <th *ngFor="let col of columns()">
              <app-table-header [column]="col"></app-table-header>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
          <tr>
            <td *ngFor="let col of columns()">
              <app-table-column [column]="col" [data]="item"></app-table-column>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="columns().length" class="text-center p-4">
              No location quick notes available.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</p-card> 